import React from 'react';
import cn from 'classnames';
import styles from './current-image.module.css';
import { DisplayImage } from './DisplayImage';


interface CurrentImageProps {
  src?: string;
}

export const CurrentImage: React.FC<CurrentImageProps> = ({ src }) => (
  <>
    {src ? (
      <DisplayImage src={src} />
    ) : (
      <p className={cn(styles.noImage)}>
        Unavailable: No image has been uploaded
      </p>
    )}
  </>
);
